<template>
  <CourseSearchPage :filter-fields="filterFields" />
</template>

<script>
import { mapState } from 'vuex'
import CourseSearchPage from '~contemporaryTheme/pages/courses/index'

export default {
  components: {
    CourseSearchPage,
  },
  computed: {
    ...mapState('departments', {
      chosenDepartments: (state) => state.chosen || state.all,
    }),
    filterFields() {
      return [
        {
          label: 'Departments',
          placeholder: 'Filter By Departments',
          questionId: 'departments',
          dataKey: 'departments',
          custom: false,
          type: 'searchSelect',
          questionType: 'select',
          config: {
            options: this.departmentOptions,
          },
          visibility: true,
          tooltipEnabled: false,
          filter: {
            group: 'course',
            id: 'departments-courses',
            inputType: 'select',
            name: 'departments',
            type: 'is',
          },
        },
      ]
    },
    departmentOptions() {
      return this.chosenDepartments.map((item) => {
        return { label: item.displayName, value: item.id }
      })
    },
  },
}
</script>
